import React from 'react';
import { Sparkles, Settings, TrendingUp } from 'lucide-react';
import { partnershipFeatures } from '../../data/mock';

const iconMap = {
  Sparkles: Sparkles,
  Settings: Settings,
  TrendingUp: TrendingUp,
};

const Partnership = () => {
  return (
    <section id="partnership" className="py-16 lg:py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-20">
          <p className="text-amber-800/80 text-base tracking-[0.2em] uppercase mb-4">
            Branded Operation Partnership
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            ブランド運営パートナーシップ
          </h2>
          <div className="w-20 h-px bg-amber-700/40 mx-auto mb-8" />
          <p className="text-lg text-stone-600 max-w-2xl mx-auto font-light leading-relaxed">
            私たちは単なる物件管理会社ではありません。<br />
            ブランド・運営・収益の3つの責任を共に担う、長期パートナーです。
          </p>
        </div>

        {/* Features grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {partnershipFeatures.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group bg-white rounded-2xl p-8 lg:p-10 shadow-sm card-hover border border-stone-100 hover:border-amber-200/50 card-gradient-accent"
              >
                <div className="mb-6">
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-amber-50 to-stone-100 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-6 h-6 text-amber-800" />
                  </div>
                </div>
              <div>
                <p className="text-sm text-amber-700/70 tracking-wider uppercase mb-2">
                  {feature.titleEn}
                </p>
                <h3 className="text-2xl font-medium text-stone-800 mb-4">
                  {feature.title}
                </h3>
                <p className="text-base text-stone-600 font-light leading-relaxed">
                  {feature.description}
                </p>
              </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Partnership;
